import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logoutUser } from "../../Authentication/modules/actions";
const mapStateToProps = (state) => ({
  user: state.user.loggedUser,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      logoutUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
